import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;
const coreBlue = colors.ui.core[500];
const coreBlue700 = colors.ui.core[700];
const neutral400 = colors.ui.neutral[400];
const neutral700 = colors.ui.neutral[700];
const white = colors.ui.white[500];

const borderColor = coreBlue;

// Fixed width for Y/N columns and Reason/Statement columns
const ynWidth = "68px";
const cellWidth = "1fr";

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "16px",
};

export const guideRowsContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const guideHeaderRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: `${cellWidth} ${ynWidth} ${cellWidth} ${ynWidth} ${cellWidth}`,
  padding: "6px 0",
  borderBottom: `4px solid ${borderColor}`,
  fontWeight: 700,
  fontSize: "16px",
  color: "#111",
  background: "white",
};

export const guideHeaderCellStatement: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "4px 8px",
  borderRight: `4px solid ${borderColor}`,
  ...typographyStyles.heading6Obj,
};

export const guideHeaderCellYN: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px",
  borderRight: `2px solid ${borderColor}`,
  minWidth: ynWidth,
  maxWidth: ynWidth,
  ...typographyStyles.heading6Obj,
};

export const guideHeaderCellReason: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "4px 8px",
  borderRight: `2px solid ${borderColor}`,
  ":last-of-type": {
    borderRight: "none",
  },
  ...typographyStyles.heading6Obj,
};

export const guideRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: `${cellWidth} ${ynWidth} ${cellWidth} ${ynWidth} ${cellWidth}`,
  alignItems: "stretch",
  padding: "6px 0",
  borderBottom: `2px solid ${borderColor}`,
  background: white,
  minHeight: "64px",
};

const cellContainer = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: "0 8px",
  minHeight: "65px",
  background: white,
};

export const guideCellStatement: CSSObject = {
  ...cellContainer,
  borderRight: `4px solid ${borderColor}`,
};

export const guideCellReason: CSSObject = {
  ...cellContainer,
  borderRight: `2px solid ${borderColor}`,
  ":last-of-type": {
    borderRight: "none",
  },
};

export const guideCellYN: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRight: `2px solid ${borderColor}`,
  minHeight: "64px",
  height: "100%",
  background: "white",
  minWidth: ynWidth,
  maxWidth: ynWidth,
};

export const ynCellCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  gap: "8px",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  width: ynWidth,
  height: "100%",
  margin: "0 auto",
  padding: "0 8px",
  borderRight: `2px solid ${borderColor}`,
};

export const radioButtonCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: 0,
  padding: 0,
  color: coreBlue700,

  "&:hover, &:focus": {
    color: coreBlue700,
  },

  "&& span": {
    width: "24px",
    height: "24px",
    marginRight: "0px",
    padding: 0,
    border: `1px solid ${neutral700}`,
  },
};

export const textareaCss = (
  isOverflowingTextarea: boolean = false,
): CSSObject => ({
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "8px 12px",
  resize: "none",
  height: "100%",
  maxHeight: "85px",
  overflowY: "hidden",
  width: "100%",
  ...(isOverflowingTextarea
    ? typographyStyles.textXSObj
    : typographyStyles.textMObj),
});
